import React, { useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./HeroSection.css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Autoplay, EffectFade } from "swiper/modules";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function HeroSlider() {
  const { RendomTokenfetch } = useAuth();
  const [sliderData, setSliderData] = useState([]);
  const [loading, setLoading] = useState(false);

  const FetchSliderData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${WebsiteAPIurl}homeSliderAPI.php`, {
        headers: {
          Authorization: RendomTokenfetch,
        },
      });
      if (response.data.status === "1") {
        setSliderData(response.data.sliderdata);
      } else {
        setSliderData([]);
      }
    } catch (error) {
      console.error("Error fetching slider:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch]);

  useEffect(() => {
    FetchSliderData();
  }, [FetchSliderData]);

  if (loading) return <APIDataFetchLoader />;

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1.5 } },
  };

  return (
    <>
      <Helmet>
        {sliderData.length > 0 && (
          <link
            rel="preload"
            as="image"
            href={sliderData[0].image}
            imagesrcset={sliderData[0].image}
            fetchpriority="high"
          />
        )}
      </Helmet>
      <section className="hero-section">
        <Swiper
          modules={[Autoplay, EffectFade]}
          spaceBetween={0}
          slidesPerView={1}
          effect="fade"
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            fadeEffect: { crossFade: true },
          }}
          speed={1500}
          loop={sliderData.length > 1}
          className="imgSlider2"
        >
          {sliderData.length > 0 &&
            (sliderData.length === 1
              ? [...sliderData, ...sliderData]
              : sliderData
            ).map((val, index) => (
              <SwiperSlide key={index}>
                <motion.div
                  className="hero-slide"
                  initial="hidden"
                  animate="visible"
                  variants={fadeIn}
                >
                  <div className="hero-image">
                    <motion.img
                      src={val.image}
                      alt={val.image_alt}
                      title={val.image_title}
                      initial={{ opacity: 0, scale: 1.05 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 1.5, ease: "easeOut" }}
                      loading="lazy"
                    />
                  </div>

                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="hero-content">
                          <div className=" dark-section">
                            <h2>{val.subtitle}</h2>

                            <motion.h1
                              className="text-anime-style-2"
                              variants={fadeUp}
                              initial="hidden"
                              animate="visible"
                              transition={{ delay: 0.2 }}
                            >
                              {val.title}
                            </motion.h1>

                            <motion.p
                              variants={fadeUp}
                              initial="hidden"
                              animate="visible"
                              transition={{ delay: 0.4 }}
                            >
                              {val.tagline}
                            </motion.p>
                          </div>

                          <motion.div
                            className="hero-btn"
                            variants={fadeUp}
                            initial="hidden"
                            animate="visible"
                            transition={{ delay: 0.6 }}
                          >
                            <Link to="/contact" className="btn-default">
                              <span>explore more</span>
                            </Link>
                          </motion.div>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
        </Swiper>
      </section>
    </>
  );
}
